import React, { Suspense, lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ErrorsPage } from 'src/modules/errors/ErrorsPage';
import { FallbackView } from '../_metronic/partials';
import { DashboardWrapper } from '../pages/dashboard';

export function PrivateRoutes() {
  const BuilderPageWrapper = lazy(() => import('../pages/layout-builder/BuilderPageWrapper'));
  const Notifications = lazy(() => import('../pages/notifications'));
  const UserSettings = lazy(() => import('../pages/user-settings'));
  const CommercialConditions = lazy(() => import('../pages/commercial-conditions'));
  const Products = lazy(() => import('../pages/products'));
  const Inventory = lazy(() => import('../pages/inventory'));
  const Campaigns = lazy(() => import('../pages/campaings'));
  const Finance = lazy(() => import('../pages/finance'));
  const Orders = lazy(() => import('../pages/orders'));
  const DealerPage = lazy(() => import('../pages/dealer-account-setting'));
  const Reports = lazy(() => import('../pages/reports/index'));
  const Support = lazy(() => import('../pages/support'));
  const Faq = lazy(() => import('../pages/faq'));

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path="/dashboard" component={DashboardWrapper} />
        <Route path="/builder" component={BuilderPageWrapper} />
        <Route path="/notifications" component={Notifications} />
        <Route path="/user-settings" component={UserSettings} />
        <Route path="/commercial-conditions" component={CommercialConditions} />
        <Route path="/orders" component={Orders} />
        <Route path="/products" component={Products} />
        <Route path="/inventory" component={Inventory} />
        <Route path="/reports" component={Reports} />
        <Route path="/support" component={Support} />
        <Route path="/campaigns" component={Campaigns} />
        <Route path="/finance" component={Finance} />
        <Route path="/account-informations" component={DealerPage} />
        {/* <Route path="/agreements" component={Agreements} /> */}
        <Route path="/faq" component={Faq} />

        <Route path="/error" component={ErrorsPage} />

        <Redirect from="/auth" to="/dashboard" />
        <Redirect exact from="/" to="/dashboard" />
        <Redirect to="error/404" />
      </Switch>
    </Suspense>
  );
}
